import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder,FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from '../../../shared/services/registration.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MasterService } from 'src/app/shared/services/master.service';
import { log } from 'console';
import { DatePipe } from '@angular/common';

declare let $: any;
@Component({
  selector: 'app-ncd-questionary',
  templateUrl: './ncd-questionary.component.html',
  styleUrls: ['./ncd-questionary.component.css']
})
export class NcdQuestionaryComponent implements OnInit {
@Input() benID:any;
@Input() memberID:any;
@Input() patientDetails:any;
@Input() ScreenName:any;


  listGrid: any[] = [];
  surveyCards: any[] = [];
  cardClick:boolean=false;
  activeTabIndex = 0;
selectedSurvey: any = null;
selectedAnswers: { [questionId: number]: any } = {};
  dependentId: null;
  surveyTransDetails: any[]=[];
  ncdSaveEnable: boolean=false;

  
 constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private master : MasterService,
    private datepipe : DatePipe
  ) { }

  ngOnInit(): void {
    this.loadData();
    if(this.ScreenName == 'patientList'){
      this.ncdSaveEnable = true
    }else{
      this.ncdSaveEnable = false
    }
    console.log('patientDetails',this.patientDetails);
    
  }

  loadData() {
    this.regService.getwithoutlogin(`survey/survey/getall`).subscribe({
      next: (res: any) => {
        if (res?.status === 'OK') {
          this.listGrid = res.data;
          this.surveyCardsList();
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message ?? 'An unexpected error occurred');
      },
    });
  }

  surveyCardsList(){
    this.surveyCards = this.listGrid.map(
      (item) => item.surveyLang?.[0]?.langStr || 'Unnamed Survey'
    );
    console.log(' this.surveyCards', this.surveyCards)
  }

 getCardColor(index: number): string {
  const customColors = [
    'card-gradient-red',
    'card-gradient-yellow',
    'card-gradient-purple',
    'card-gradient-teal',
    'card-gradient-orange',
    'card-gradient-green',
    'card-gradient-pink',
    'card-gradient-blue',
    'card-gradient-lime',
    'card-gradient-cyan',
    'card-gradient-brown',
    'card-gradient-indigo',
    'card-gradient-gray'
  ];
  return customColors[index % customColors.length];
}

getCardIcon(index: number): string {
  const icons = [
    'fas fa-notes-medical',       // CBAC History
    'fas fa-syringe',             // Diabetes
    'fas fa-stethoscope',         // Hypertension
    'fas fa-tooth',               // Oral
    'fas fa-heartbeat',           // Cardiac
    'fas fa-lungs',               // Respiratory
    'fas fa-dna',                 // Genetic
    'fas fa-brain',               // Neuro
    'fas fa-user-nurse',          // Nurse Checkup
    'fas fa-vial',                // Lab
    'fas fa-eye',                 // Vision
    'fas fa-bone',                // Bone Health
    'fas fa-briefcase-medical'    // General
  ];
  return icons[index % icons.length];
}

 onCardClick(surveyName: string) {
  this.selectedSurvey = this.listGrid.find(
    item => item.surveyLang?.[0]?.langStr === surveyName
  );
  this.activeTabIndex = 0;
  this.cardClick = true;
  this.initializeSelectedAnswers(); // initialize defaults here
}
initializeSelectedAnswers(): void {
  if (this.selectedSurvey?.sections) {
    for (let section of this.selectedSurvey.sections) {
      for (let question of section.questions) {
        if (!(question.id in this.selectedAnswers)) {
          this.selectedAnswers[question.id] = null;
        }
      }
    }
  }
}


submitSurvey() {
  console.log('Saved Answers for:', this.selectedSurvey.surveyLang[0]?.langStr);
  console.log(this.selectedAnswers);
   if (this.activeTabIndex < this.selectedSurvey.sections.length - 1) {
    this.activeTabIndex++;
  } else {
    // ✅ Optional: final submit logic
    console.log('Survey complete!');
  }
}
goToPreviousTab(): void {
  if (this.activeTabIndex > 0) {
    this.activeTabIndex--;
  }
}

getSectionLabel(section: any, index: number): string {
  return section?.sectionLang && section.sectionLang.length
    ? section.sectionLang[0].langStr
    : `Section ${index + 1}`;
}

getQuestionLabel(question: any): string {
  return question?.questionLang && question.questionLang.length
    ? question.questionLang[0].langStr
    : `Question ${question.id}`;
}

getAnswerLabel(answer: any): string {
  return answer?.answerLang && answer.answerLang.length
    ? answer.answerLang[0].langStr
    : '';
}

close(){
 this.cardClick=false; 
}

updateSurveyDetail(question: any, rawAnswer: any, type:any): void {
const questionId = question.questionLang?.[0]?.questionID || question.id;
const survey_id = this.selectedSurvey?.surveyLang[0]?.surveyID;
let answer = rawAnswer?.target?.value ?? rawAnswer;  // safely get value

 answer = rawAnswer?.target?.value ?? rawAnswer;
 if(type == 'checkBox'){
  answer = rawAnswer?.target?.checked || rawAnswer
 }
 if(type == 'radio'){
 answer = rawAnswer
 }

if (answer instanceof Date || (!isNaN(Date.parse(answer)) && typeof answer === 'string') && type === 'date' ) {
  const date = new Date(answer);
  answer = this.datepipe.transform(date,'yyyy-MM-dd')

}


// Step 1: Find existing index
const existingIndex = this.surveyTransDetails.findIndex(
  item => item.question_id === questionId && item.survey_id === survey_id
);

// Step 2: If answer is empty, remove existing entry if found
const isEmpty =
  answer === null ||
  answer === undefined ||
  (typeof answer === 'string' && answer.trim() === '');
  
if (isEmpty) {
  if (existingIndex !== -1) {
    this.surveyTransDetails.splice(existingIndex, 1);
    console.log(`Removed entry for question_id=${questionId}, survey_id=${survey_id}`);
  }
} else {
  const newEntry = {
    survey_id: survey_id,
    question_id: questionId,
    answer: answer,
    visit_no : null
  };

  if (existingIndex !== -1) {
    this.surveyTransDetails[existingIndex] = newEntry; // Update
  } else {
    this.surveyTransDetails.push(newEntry); // Add new
  }
}

console.log('this.surveyTransDetails', this.surveyTransDetails);

}


onSubmit() {

  let payload = [{
    surveyTransMaster: {
      beneficiary_id: this.benID || null,  // set this in your component
      dependent_id: this.memberID || null,
      survey_id: this.selectedSurvey?.id,
      created_by: sessionStorage.loginId,             // set this in your component
      summary: {},
      language_id: 1                       // or get from user/session
    },
    surveyTransDetails: this.surveyTransDetails
  }];

  this.regService.getwithoutloginpost(`survey/survey-trans-master/save`, payload).subscribe({
    next: res => {
      if (res.status === 'OK') {
        this.activeModal.close('Close click') 
        this.toastr.success(res.message);
      } else {
        this.toastr.error(res.message);
      }
    },
    error: (err: HttpErrorResponse) => {
      this.toastr.error(err.message);
    }
  });
}

onSubmit2(){
   let payload = [{
    surveyTransMaster: {
      beneficiary_id: this.benID || null,  // set this in your component
      dependent_id: this.memberID || null,
      survey_id: this.selectedSurvey?.id,
      created_by: sessionStorage.loginId,             // set this in your component
      summary: {},
      language_id: 1                       // or get from user/session
    },
    surveyTransDetails: this.surveyTransDetails
  }];
  console.log('ncdPayload',payload)
      this.activeModal.close(payload)
}



}
